import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { logoutFromHelper } from "api/Helper";
import { pathGenerators } from "utils/routes";

import { logout } from "../redux/auth/AuthSlice";
import { removeuser } from "../redux/user/userSlice";

export const useErrorHandler = (options = {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast = true } = options;

  return (error, customMessage) => {

    if (showToast) {
      if (customMessage) {
        toast.error(customMessage, { duration: 10000 });
      } else if (error?.response?.data?.message) {
        toast.error(error.response.data.message, { duration: 10000 });
      } else if (error?.message) {
        toast.error(error.message, { duration: 10000 });
      } else {
        toast.error("An error occurred", { duration: 10000 });
      }
    }

    if (error?.response?.status === 403) {
      logoutFromHelper();
      dispatch(logout());
      dispatch(removeuser());
      navigate(pathGenerators.auth.logout());
    }
  };
};
